import { App, RedirectService } from '@agilox/common';
import { ButtonComponent } from '@agilox/ui';
import { Component, computed, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { helpDeskLink } from '../../models/consts/helpdesk-link.const';

@Component({
	selector: 'manage-help-content',
	templateUrl: './help-content.component.html',
	imports: [ButtonComponent, TranslatePipe],
})
export class HelpContentComponent {
	private redirectService = inject(RedirectService);

	environment = input.required<string>();

	closed = output<void>();

	docsUrl = computed(() => this.redirectService.getRedirectAppUrl(App.docs, this.environment()));

	onOpenDocs() {
		this.closed.emit();
	}

	onCreateTicket() {
		this.closed.emit();
	}

	onCancel() {
		this.closed.emit();
	}

	protected readonly helpDeskLink = helpDeskLink;
}
